import BaseSetup from '@/components/BaseSetup';
import OrganizationRoleListItemEntity from '@/entity/OrganizationRoleListItemEntity';
import useOrganizationRoleService from '@/services/organization/OrganizationRoleService';
import { Reactive } from '@/utils/decorators';

export type SharedRoleSelectEmits = {
	(e: 'update:modelValue', val: number | number[] | undefined): void
};
export type SharedRoleSelectProps = {
	multiple?: boolean
	modelValue?: number | number[]
};

export default class SharedRoleSelectSetup extends BaseSetup {

	static readonly defaultProps = {};

	@Reactive private readonly state = {
		dataLoaded: false,
		options: [] as OrganizationRoleListItemEntity[],
	};

	get dataLoaded () { return this.state.dataLoaded }
	get options () { return this.state.options.sort((a, b) => (a.name ?? '').localeCompare(b.name ?? '')) }

	get selectedRolesIds () { return this.props.modelValue }
	set selectedRolesIds (val) { this.emits('update:modelValue', val) }

	constructor (
		private props: SharedRoleSelectProps,
		private emits: SharedRoleSelectEmits,
	) {
		super();
	}

	async onBeforeMountAsync () {
		this.state.options = OrganizationRoleListItemEntity.map(await useOrganizationRoleService().listAsync());
		this.state.dataLoaded = true;
	}

	getRoleById (id: number) {
		return this.state.options.findByKey(id);
	}

}
